// extracted by mini-css-extract-plugin
export default {"body":"layout_body__g7R4Q","main__container":"layout_main__container__Xv2dP","layout":"layout_layout__gE1D+"};